<router-outlet></router-outlet>

<section id="loading" class="d-flex justify-content-center align-items-center" *ngIf="loading">
    <img src="/assets/images/loading-yellow.gif" alt="loading" />
</section>